import React from "react";
import { NavLink } from "react-router-dom";
import "./Home.css";

const HomeComponent = () => {
  return (
    <div>
      <div className="SideNav">
        <ul>
          <li>
            <NavLink to="/generate" activeClassName="my-active">
              Generate
            </NavLink>
          </li>
          <li>
            <NavLink to="/search" activeClassName="my-active">
              Search
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin" activeClassName="my-active">
              Admin Portal
            </NavLink>
          </li>
          <li>
            <NavLink to="/genHistory" activeClassName="my-active">
              Generation History
            </NavLink>
          </li>
          <li>
            <NavLink to="/logout" activeClassName="my-active">
              Logout
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HomeComponent;
